// Firebase configuration for Production (jaimee-f1e16)
const firebaseConfig = {
  apiKey: "AIzaSyAan5-RyCTfIc59nw2JgqMshLqBIJ1uAG4",
  authDomain: "jaimee-f1e16.firebaseapp.com",
  projectId: "jaimee-f1e16",
  storageBucket: "jaimee-f1e16.firebasestorage.app",
  messagingSenderId: "1098044946157",
  appId: "1:1098044946157:web:c98c680ef399832dc5bee4",
  measurementId: "G-2KDX01W171"
};

export default firebaseConfig;
